import React from 'react'
export default function veg() {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="14" height="14" rx="2.5" fill="white" stroke="#289C3A"/>
<circle cx="7.50059" cy="7.49961" r="3.9" fill="#289C3A"/>
</svg>

  )
}